import React from 'react';
import PropTypes from 'prop-types';
import { Box, Flex, Text, IconButton } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Button, InviteLink } from '../../';
import { InterpretationIcon } from '../../../images/index';
import { Mode } from './sessionTable';
import { SessionStatus } from '../../../redux/reducers';
import SessionDetails from './sessionDetails';

const SessionRow = ({
  session,
  mode,
  onSessionStartHandler,
  onEditHandler,
  onRemoveHandler,
  onFinishHandler,
}) => {
  const { t } = useTranslation();

  const Buttons = () => {
    return (
      <Flex fontWeight="bold" position="absolute" bottom="0" mb={4}>
        {mode === Mode.Upcoming && (
          <Button
            fontWeight="bold"
            color="brand.60"
            onClick={() => onEditHandler(session)}
            bg={null}
            mr={32}
            p={0}
            _hover={{ bg: null }}
          >
            {t('common.edit')}
          </Button>
        )}
        <Button
          fontWeight="bold"
          color="brand.60"
          onClick={() => onRemoveHandler(session)}
          bg={null}
          p={0}
          _hover={{ bg: null }}
        >
          {t('common.remove')}
        </Button>
      </Flex>
    );
  };

  const FinishButton = () => {
    return (
      <Button
        fontWeight="bold"
        color="brand.60"
        onClick={() => onFinishHandler(session)}
        bg={null}
        p={0}
        _hover={{ bg: null }}
      >
        {t('common.finish')}
      </Button>
    );
  };

  const getStatus = () => {
    if (session.status === SessionStatus.NEW) {
      return t('interpreter.statusNotStarted');
    } else if (session.status === SessionStatus.ONGOING) {
      return t('interpreter.statusOngoing');
    } else {
      return t('interpreter.statusFinished');
    }
  };

  const startButtonStr =
    session.status === SessionStatus.NEW
      ? t('interpreter.startSession')
      : t('interpreter.joinSession');

  const durationSeconds =
    mode === Mode.Upcoming ? session.estimatedDurationSeconds : session.actualDurationSeconds;
  return (
    <Box height="100%" borderBottom="solid 2px" borderColor="brand.80" pt={4}>
      <Flex>
        <SessionDetails
          height="100%"
          flexGrow={1}
          session={session}
          durationSeconds={durationSeconds}
          status={getStatus()}
        />
        {mode === Mode.Upcoming && (
          <Flex flexDir="column" alignItems="center" whiteSpace="nowrap">
            <Text>{startButtonStr}</Text>
            <IconButton
              onClick={() => onSessionStartHandler(session)}
              my="4"
              variant="unstyled"
              bg={null}
              icon={<InterpretationIcon />}
            ></IconButton>
          </Flex>
        )}
      </Flex>
      {mode === Mode.Upcoming && <InviteLink my={4} url={session.url} />}
      {session.status !== SessionStatus.ONGOING && <Buttons />}
      {session.status === SessionStatus.ONGOING && <FinishButton />}
    </Box>
  );
};

SessionRow.propTypes = {
  session: PropTypes.object.isRequired,
  mode: PropTypes.string.isRequired,
  onSessionStartHandler: PropTypes.func.isRequired,
  onEditHandler: PropTypes.func.isRequired,
  onRemoveHandler: PropTypes.func.isRequired,
  onFinishHandler: PropTypes.func.isRequired,
};

SessionRow.defaultProps = {};

export default SessionRow;
